<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    :append-to-body="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('feedback.reply')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="formLeft"
        :rules="rulesCenter"
        :model="formInfo"
        :label-position="'right'"
        label-width="0"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item prop="message">
              <el-input
                v-model="formInfo.message"
                :rows="6"
                maxlength="500"
                show-word-limit
                :autosize="{ minRows: 6, maxRows: 6}"
                resize="none"
                type="textarea"
                placeholder="Enter"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { replyData } from '@/api/userCenter/feedback'

export default {
  name: 'replyDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatefaultContent = (rule, value, cb) => {
      if (value === '' || value === undefined) {
        return cb(new Error(vm.$t('feedback.message1')))
      }
      if (value.length > 500) {
        return cb(new Error(this.$t('public.lengthMessage') + ' 500'))
      }
    }
    return {
      formInfo: {},
      rulesCenter: {
        message: [
          { required: true, trigger: 'blur', validator: validatefaultContent },
          { trigger: 'change', validator: validatefaultContent }
        ]
      }
    }
  },
  created() {
  },
  methods: {

    // 关闭
    closeDialog() {
      this.formInfo.message = ''
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    // 提交
    handleSubmit() {
      const formCheckLeft = this.checkForm({
        formName: 'formLeft',
        formList: ['message']
      })
      if (!formCheckLeft) {
        return
      }
      const {...postData } = this.formInfo
      for (const k in postData) {
        if (postData[k] === undefined) {
          postData[k] = ''
        }
      }
      postData.feedbackId = this.data.feedbackId
      this._createFaultCode(postData)
    },
    // 新增
    _createFaultCode(postData) {
      replyData(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('reply-complete')
          this.closeDialog()
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
